module.exports = __webpack_public_path__ + "img/Still-Thinking-3.129bb101.png";